import { LectioJSUtils } from '../LectioJSUtils';
import { LCDocumentEditorUtils } from '../LC/LCEntry';
import { ensureLectioIds } from './PluginEnsureId';
import { CKEditorEx, ILectioPlugin } from './Types';

export type HeaderTag = 'h1' | 'h2' | 'h3' | 'p';
export type HeaderVariant = 'activity' | 'resources' | 'homework' | 'other' | 'presentation' | 'teacherfeedback';
export type RecognizedHeaderCombo = { readonly tag: HeaderTag, readonly variant: HeaderVariant | null, readonly isPreferred: boolean, ['-flooz']: 42 };

const headerVariantAttributeName: string = 'data-lc-header-variant';
const headerDisplayInfoAttributeName: string = 'data-lc-display-header-info';

const headerIsPublicAttributeName: string = 'data-lc-header-ispublic';

type CKTristate = 0 | 1 | 2; // ckeditor.tristate_xxx

/**
 * Dette er et forsoeg paa at tilfoje knapper til h1-, h2- og h3-elementer,
 * saa man kan saette lektie-egenskaber paa dem.
 */
export class PluginCommentBlock2 implements ILectioPlugin {
	public static FixHeaders(editor: CKEDITOR.editor) {
		HeaderFunctions.FixHeaders(editor);

	}

	public Init(): void {

		CKEDITOR.plugins.add('lectiocommentblock2', {
			hidpi: true,
			init: (editor: CKEDITOR.editor) => {

				const config = LCDocumentEditorUtils.GetEditorConfig(editor);
				const fmat = config.enableHomeworkHeadings;

				editor.addCommand('lectioNote', CreateNoteCommand(!fmat));
				editor.ui.addButton('LectioNote', {
					label: "Note",
					title: 'Indsæt lektie-/aktivitetsnote',
					command: 'lectioNote',
					icon: '/lectio/img/note.auto',
					toolbar: ''
				});

				editor.ui.addRichCombo('LectioFormat', CreateLectioFormatCombo(editor, fmat));
				editor.ui.addRichCombo('LectioFormat2', CreateLectioFormatCombo(editor, fmat));
				editor.addCommand('lectioIsPublic', CreateIsPublicCommand());

				if (!fmat)
					return;

				editor.on('instanceReady', () => {
					const editable = editor.editable();
					if (!editable)
						throw new Error('Har ikke editable?!');
					editable.addClass('lc-display-editor-withhomeworkheadingbuttons');
					editable.addClass('ls-phase-material');

					if (1 === parseInt('2', 10)) {
						HeaderFunctions.RegisterUpdateAffectedHeadings(editor);
					}
				});

				editor.ui.addButton('LectioIsPublic', {
					label: "Offentlig",
					command: 'lectioIsPublic',
					//					icon: '/lectio/img/transparent.auto',
					toolbar: ''
				});

				// Initialiserer paa dataReady isf. fx. instanceReady for ogsaa at blive
				// kaldt efter indlaesning af backup med setData().
				editor.on('dataReady', () => {
					if (!editor.document) {
						// ved "Vis kilde" bliver vi kaldt, og der er editor.document undefined.
						return;
					}
					for (const h of editor.document.find('h1, h2, h3').toArray()) {
						HeaderFunctions.UpdateHeaderInfoDisplayAttribute(h, 'derive');
					}
				});
				// Ved paste fra anden editor bliver displayinfo fjernet af filtret. Derfor
				// soerger vi her for at den bliver sat igen.
				editor.on('afterPaste', () => {
					for (const h of editor.document.find('h1, h2, h3').toArray()) {
						HeaderFunctions.UpdateHeaderInfoDisplayAttribute(h, 'derive');
					}
				});

				editor.on('key', OnNoteKey);

				createHeadingBalloontoolbar(editor);
			}
		});
	}
}

function createHeadingBalloontoolbar(editor: CKEDITOR.editor) {
	const toolbarctx = editor.balloonToolbars.create({
		buttons: 'LectioNote,LectioIsPublic,LectioFormat2',
		// refreshx: (editor, path, selection) => {
		// 	const range = selection.getRanges()[0];

		// 	// Vi vil helst kun vises naar der selection er i een header, derfor de flg. linier.
		// 	// Men balloontoolbar spoerger kun igen, naar startPath aendrer sig, saa koden her er ikke tilstraekkelig:
		// 	// Knapperne maa kun manipulere headeren i startPath.
		// 	const start = GetHeaderElement(range.startPath());
		// 	const end = GetHeaderElement(range.endPath());
		// 	return !!start && !!end && start.equals(end) && start.getParent().hasClass('cke_editable') ? start : false;
		// }
	});
	const toolbar = toolbarctx.toolbar;

	// richcombo vil gerne placere comboen ud for sin knaps nedre venstre hjoerne.
	// Det fungerer ikke godt naar der ikke er plads nok til hoejre for dette punkt,
	// for saa flipper comboen til venstre og placerer oeverste HOEJRE hjoerne der.
	// Derfor braekker vi den og dens panel op for at faa den til at placere
	// sig ift. knappens nederste hoejre hjoerne.
	const comboboxTmp = editor.ui.get('LectioFormat2');
	if (!(comboboxTmp instanceof CKEDITOR.ui.richCombo))
		throw new Error('ikke richcombo?!');
	const combobox = comboboxTmp as LectioRichCombo;
	if (!('lectioUpdateComboInBallonPanel' in combobox))
		throw new Error('mangler lectioUpdateComboInBallonPanel');

	type RichPanelEx = {
		createPanel: (this: CKEDITOR.ui.richCombo & { _: { panel: CKEDITOR.ui.floatPanel | undefined } }, editor: CKEDITOR.editor) => void;
	};

	const comboboxAny: RichPanelEx = combobox as any;
	const cp = comboboxAny.createPanel;
	comboboxAny.createPanel = function (editor: CKEDITOR.editor) {
		const hadPanel = !!this._.panel;

		cp.call(this, editor);
		const floatPanel = this._.panel;
		const shouldHackPanel = !hadPanel && !!floatPanel;
		if (!shouldHackPanel)
			return;
		if (!floatPanel)
			throw new Error('come on, ts, panel er ikke undefined her.');

		if (!LectioJSUtils.False())
			return;

		const sb = floatPanel.showBlock;
		floatPanel.showBlock = function (name, offsetParent, corner, offsetX, offsetY, callback) {
			// 3 betyder nederste hoejre hjoerne. richcombo angiver 4.
			// TODO Erstat kun med 3 naar der ikke er horisontal plads nok.
			sb.call(this, name, offsetParent, 3, offsetX, offsetY, callback);
		};
	};

	// balloontoolbar er ikke meget for at rykke vaek fra midten og ud i hoejre side ved vores "knap" hvor vi gerne vil have den.
	// Derfor bryder vi her ind i dens "balloonPanel"'s positionsberegning.
	const tb = toolbar as any;
	const tbAttach = tb.attach;
	let lastAttachedElement: HTMLElement | null = null;
	tb.attach = function (element: CKEDITOR.dom.element, options: any) {
		lastAttachedElement = element.$;
		return tbAttach.call(this, element, options);
	};
	tb._view._getAlignments = (elementRect: { top: number, left: number, width: number, right: number; },
		panelWidth: number, panelHeight: number) => {
		// const alignments = CKEDITOR.ui.balloonPanel.prototype._getAlignments.call(this, elementRect, panelWidth, panelHeight);
		// return alignments;

		// Kan ikke bruge elementRect.width, for den afspejler "kun" hvor bred teksten er.
		const editable = editor.editable()!;
		const apprHeaderWidth = parseFloat(editable.getComputedStyle('width'));
		if (isNaN(apprHeaderWidth))
			throw new Error('Kan ikke bestemme bredde.');

		const pwidth = panelWidth === 0 ? 260 : 0;
		if (panelWidth === 0)
			LectioJSUtils.LogDebug('toolbar, _getAlignments: Faar bredden 0, defaulter til noget lidt mere passende: ' + pwidth);

		if (!(lastAttachedElement instanceof HTMLElement))
			throw new Error('Attachet til noget der ikke er htmlelement.');
		const cs = window.getComputedStyle(lastAttachedElement);
		const paddingTop = parseInt(cs.paddingTop || '0', 10);
		const borderTop = parseInt(cs.borderTop || '0', 10);

		return {
			'top hcenter': {
				top: elementRect.top - 35 + borderTop + paddingTop,
				left: elementRect.left + apprHeaderWidth - 10 - pwidth
			},
		};
	};

	editor.on('contentDom', () => {
		const editable = editor.editable()!;

		editable.attachListener(editable, 'click', evt => {
			const nativeEvent = evt.data.$;
			if (!(nativeEvent instanceof MouseEvent))
				throw new Error('click uden native mouse event?');
			const target = nativeEvent.target;
			if (!(target instanceof HTMLElement))
				return;

			const ele = new CKEDITOR.dom.element(target);
			const header = HeaderFunctions.GetHeaderElement(new CKEDITOR.dom.elementPath(ele));
			if (!header)
				return;
			const rect = header.getClientRect();
			const cs = window.getComputedStyle(target);
			const contentY = nativeEvent.offsetY - parseInt(cs.paddingTop || '0', 10);
			const estimatedButtonWidth = 100;
			const show = contentY > -25 && contentY < 0 && nativeEvent.x >= rect.width - (estimatedButtonWidth + parseInt(cs.paddingRight || '0', 10));
			if (!show)
				return;

			// Headerstyle og manipulationer sker generelt paa
			// selection. Derfor er det vigtigt at selection i det mindste starter i headeren.
			const rr = editor.getSelection()!.getRanges()[0];
			const moveSelectionToHeader = !header.contains(rr.startContainer);
			if (moveSelectionToHeader) {
				const r = editor.createRange();
				r.setStart(header, 0);
				r.setEnd(header, 0);
				r.select();
			}

			toolbar.hide();
			toolbar.attach(header, true);
			// Hvis vi show med det samme, har den det med at vise sig et splitsekund og forsvinde igen.
			// Sommetider. Sommetider opfoerer den sig ordentlig. Chrome 64. ckeditor 4.8.
			setTimeout(() => {
				toolbar.show();

				combobox.lectioUpdateComboInBallonPanel();
			}, 10);
		});
		// 20180209 Forsoeg paa at faa IE til at vise anden cursor ved mus over chevron.
		// Ufaerdig, men falder paa at IE er ligeglad med at cursor bliver sat:
		// https://ckeditor.com/old/forums/CKEditor/Cursor-bug-in-IE-and-Opera-for-inline-editor
		if (CKEDITOR.env.ie && LectioJSUtils.False()) {
			let lastHeader: { header: HTMLElement } | null = null;
			editable.attachListener(editable, 'mousemove', evt => {
				const nativeEvent = evt.data.$;
				if (!(nativeEvent instanceof MouseEvent))
					throw new Error('click uden native mouse event?');

				const target = nativeEvent.target;
				if (!(target instanceof HTMLElement)) {
					editable.$.style.cursor = '';
					lastHeader = null;
					return;
				}

				const header = HeaderFunctions.GetHeaderElement(new CKEDITOR.dom.elementPath(new CKEDITOR.dom.element(target)));
				if (!header) {
					editable.$.style.cursor = '';
					lastHeader = null;
					return;
				}

				// editable.$.style.cursor = 'pointer';
				$(editable.$).css('cursor', 'pointer');
				lastHeader = { header: target };
			});
		}
	});
}

namespace HeaderFunctions {
	export const validHeaderCombos: readonly RecognizedHeaderCombo[] = (() => {
		// LectioCodeSync: lc-validheadercombos
		const validHeaderCombosx: readonly [HeaderTag, HeaderVariant | null, boolean][] = [
			['p', null, true],

			['h1', null, true],
			['h1', 'activity', true],
			['h1', 'resources', true],

			['h1', 'homework', false],
			['h1', 'other', false],
			['h1', 'presentation', false],
			['h1', 'teacherfeedback', false],

			['h2', null, true],
			['h2', 'homework', true],
			['h2', 'other', true],
			['h2', 'presentation', true],
			['h2', 'teacherfeedback', true],

			['h3', null, true],

			['h3', 'homework', false],
			['h3', 'other', false],
			['h3', 'presentation', false],
			['h3', 'teacherfeedback', false],
		];
		return validHeaderCombosx.map(([tag, variant, isPreferred]) => ({ tag: tag, variant: variant, isPreferred: isPreferred } as RecognizedHeaderCombo));
	})();

	export function GetRecognizedHeaderCombo(tag: HeaderTag, variant: HeaderVariant | null): RecognizedHeaderCombo | null {
		const matches = validHeaderCombos.filter(combo => combo.tag === tag && combo.variant === variant);
		if (matches.length === 0 && tag !== 'p')
			return null;
		const m = matches[0];
		if (!m)
			throw new Error('null??');
		return m;
	}

	export function GetRecognizedHeaderVariantAttributeValue(element: CKEDITOR.dom.element): HeaderVariant | null {
		const tag = element.getName();
		const ht = HeaderFunctions.ValidateHeaderTagNameCore(tag);
		if (!ht)
			return null;
		const hv = HeaderFunctions.ValidateHeaderTagVariantCore(element.getAttribute(headerVariantAttributeName) || 'oh no');
		const rr = HeaderFunctions.GetRecognizedHeaderCombo(ht, hv);
		return rr ? rr.variant : null;
	}

	export function GetRecognizedHeaderComboForElement(element: CKEDITOR.dom.element): RecognizedHeaderCombo | null {
		const ht = ValidateHeaderTagNameCore(element.getName());
		if (!ht)
			return null;
		const variant = ValidateHeaderTagVariantCore(element.getAttribute(headerVariantAttributeName) || 'jeezz');
		const combo = GetRecognizedHeaderCombo(ht, variant);
		if (combo)
			return combo;
		const bareCombo = GetRecognizedHeaderCombo(ht, null);
		if (!bareCombo)
			throw new Error('huh, ikke nogen bareCombo?? tag=' + ht);
		return bareCombo;
	}

	export function GetRecognizedHeaderCombosForTag(tag: string, includeNonPreferred: boolean): readonly RecognizedHeaderCombo[] | null {
		if (tag === 'p' || ValidateHeaderTagNameCore(tag) === null)
			return null;
		const matches = validHeaderCombos.filter(combo => combo.tag === tag && (includeNonPreferred || combo.isPreferred));
		return matches;
	}

	export function FixHeaders(editor: CKEDITOR.editor): void {
		const range = editor.createRange();
		range.selectNodeContents(editor.document.getBody());

		FixHeadersInRange(range);
	}

	function FixHeadersInRange(range: CKEDITOR.dom.range): void {
		const walker = new CKEDITOR.dom.walker(range);
		while (true) {
			const n = walker.next();
			if (!n)
				break;
			if (!(n instanceof CKEDITOR.dom.element))
				continue;
			const name = n.getName();
			if (name === 'h1' || name === 'h2' || name === 'h3') {
				LectioJSUtils.LogDebug('editor savesnapshot. Element: ', n.getName(), n.getText());
				UpdateHeaderInfoDisplayAttribute(n, 'derive');
			}
		}
		const sp = range.startPath();
		for (const el of sp.elements)
			UpdateHeaderInfoDisplayAttribute(el, 'derive');
		const ep = range.startPath();
		if (!ep.compare(sp)) {
			for (const el of ep.elements)
				UpdateHeaderInfoDisplayAttribute(el, 'derive');
		}
	}
	export function RegisterUpdateAffectedHeadings(editor: CKEDITOR.editor) {
		// Soerg for at opdatere overskriftsinfoattributter nar dokumentet redigeres.
		// 20180129 RH: Bruges ikke, da det maaske alligevel ikke er noedvendigt at reagere paa modifikationer.
		// Hvis det skal tages i brug, boer attributmodifikationen her i plugincommentblock2 ikke selv opdatere visningsattributten,
		// men overlade det til naervaerende kode, for at soerge for at den bliver motioneret.

		let isActive = false;
		editor.on('saveSnapshot', () => {
			if (isActive)
				return;
			isActive = true;
			try {
				const sel = editor.getSelection();
				if (!sel)
					return;
				const range = sel.getRanges()[0];
				FixHeadersInRange(range);
			}
			finally {
				isActive = false;
			}
		}, null, null, 8);
	}

	export function GetHeaderVariantTitle(variant: HeaderVariant): string {
		switch (variant) {
			case 'activity': return 'Aktivitet';
			case 'resources': return 'Ressourcer';
			case 'homework': return 'Lektie';
			case 'other': return 'Øvrigt indhold';
			case 'presentation': return 'Præsentation';
			case 'teacherfeedback': return 'Elevfeedback (lærerafsnit)';
			default:
				LectioJSUtils.AssertNever(variant, 'variant');
				throw new Error('variant never');
		}
	}

	export function GetHeaderTagTitle(tag: HeaderTag): string {
		switch (tag) {
			case 'h1': return 'Overskrift 1';
			case 'h2': return 'Overskrift 2';
			case 'h3': return 'Overskrift 3';
			case 'p': throw new Error('P er en af vaerdierne af praktisk hensyn, men hvorfor kaldes denne funktion med p?');
			default:
				const n: never = tag;
				throw new Error('Ukendt: ' + tag);
		}
	}

	export function GetHeaderTagAndVariantDisplay(tag: HeaderTag, variant: HeaderVariant | null, includeTag: boolean): string {
		if (includeTag) {
			if ((variant === 'resources' || variant === 'activity') && tag === 'h1')
				return GetHeaderVariantTitle(variant);
			const tagDisplay = tag === 'p' ? 'Normal' : GetHeaderTagTitle(tag);
			return tagDisplay + (variant ? ' - ' + GetHeaderVariantTitle(variant) : '');
		}
		if (variant)
			return GetHeaderVariantTitle(variant);
		if (tag === 'p')
			return '';
		return GetHeaderTagTitle(tag);
	}

	export function SerializeHeaderData(tag: HeaderTag, variant: HeaderVariant | null): string {
		return tag + (variant ? ' ' + variant : '');
	}

	export function DeserializeHeaderData(serialized: string): { tag: HeaderTag, variant: HeaderVariant | null } {
		const parts = serialized.split(' ');
		if (!(parts.length === 1 || parts.length === 2))
			throw new Error('deserializeHeaderData: Ikke to dele: "' + serialized + '".');

		const tagPart = ValidateHeaderTagNameCore(parts[0]);
		if (!tagPart)
			throw new Error('deserializeHeaderData: tag part er ugyldig: "' + serialized + '".');

		if (parts.length === 1)
			return { tag: tagPart, variant: null };

		const variantPart = ValidateHeaderTagVariantCore(parts[1]);
		if (!variantPart)
			throw new Error('deserializeHeaderData: variant part er ugyldig: "' + serialized + '".');

		return { tag: tagPart, variant: variantPart };
	}

	export function ValidateHeaderTagNameCore(tag: string): HeaderTag | null {
		const tmp = tag as HeaderTag;
		switch (tmp) {
			case 'h1':
			case 'h2':
			case 'h3':
			case 'p':
				return tmp;
			default:
				const n: never = tmp;
				return null;
		}
	}

	export function ValidateHeaderTagName(tag: string): HeaderTag {
		const rv = ValidateHeaderTagNameCore(tag);
		if (!rv)
			throw new Error('Er ikke header tag: ' + tag);
		return rv;
	}

	export function ValidateHeaderTagVariantCore(variant: string): HeaderVariant | null {
		const tmp = variant as HeaderVariant;
		switch (tmp) {
			case 'activity':
			case 'resources':
			case 'homework':
			case 'other':
			case 'presentation':
			case 'teacherfeedback':
				return tmp;
			default:
				const n: never = tmp;
				return null;
		}
	}

	export function ValidateHeaderTagVariant(variant: string): HeaderVariant {
		const tmp = ValidateHeaderTagVariantCore(variant);
		if (!tmp)
			throw new Error('Er ikke header variant: ' + variant);
		return tmp;
	}

	export function UpdateHeaderInfoDisplayAttribute(
		header: CKEDITOR.dom.element,
		headerConfig: {
			tag: HeaderTag, variant: HeaderVariant | null
		} | 'derive' | 'clear'
	): void {
		let tag: HeaderTag | null;
		let variant: HeaderVariant | null;

		if (headerConfig === 'derive') {
			tag = ValidateHeaderTagNameCore(header.getName());
			const variantRaw = header.getAttribute(headerVariantAttributeName);
			variant = variantRaw ? ValidateHeaderTagVariantCore(variantRaw) : null;
		}
		else if (headerConfig === 'clear') {
			tag = null;
			variant = null;
		}
		else {
			tag = headerConfig.tag;
			variant = headerConfig.variant;
		}

		let displayCore: string;

		// Her reagerer vi kun paa nogle kombinationer og vaerdier.
		// Maaske en fejlbesked eller lignende ville vaere bedre...
		if (!tag) {
			displayCore = '';
		} else {
			displayCore = GetHeaderTagAndVariantDisplay(tag, variant, false);
		}

		const showIsPublic = tag ? SupportsIsPublic(tag, variant) : false;
		if (showIsPublic) {
			const ispublic = header.getAttribute(headerIsPublicAttributeName) !== null;
			if (ispublic)
				displayCore += ', Offentlig';
		}

		// kan ikke saette den tomme streng med mindre det er et p-element,
		// for med den tomme streng forsvinder baggrundsbilledet der indikererer at der er en menu.
		const display = tag && tag !== 'p' ? displayCore || '\u200d' : displayCore;
		if (display)
			header.setAttribute(headerDisplayInfoAttributeName, display);
		else
			header.removeAttribute(headerDisplayInfoAttributeName);
	}

	export function SupportsIsPublic(tag: HeaderTag, variant: HeaderVariant | null): boolean {
		// LectioCodeSync: lc-supportsispublic
		if (tag !== 'p' && (variant === 'homework' || variant === 'other'))
			return true;
		return false;
	}

	export function GetHeaderElement(selection: CKEDITOR.dom.selection | CKEDITOR.dom.range | CKEDITOR.dom.elementPath): CKEDITOR.dom.element | null {
		let sp: CKEDITOR.dom.elementPath | null = null;
		if (selection instanceof CKEDITOR.dom.range) {
			sp = selection.startPath();
		}
		else if (selection instanceof CKEDITOR.dom.selection) {
			// Flg. metode er afledt af editor.elementPath, her kan der blot arbejdes med en anden selection
			// end den editoren har pt..
			const ele = selection.getStartElement();
			sp = new CKEDITOR.dom.elementPath(ele);
		}
		else
			sp = selection;

		// Vil kun genkende h1-3 der ligger i roden af editoren.
		if (!sp.blockLimit.hasClass('cke_wysiwyg_div'))
			return null;
		const topLevelElement = sp.block;
		if (!topLevelElement)
			return null;
		if (topLevelElement.is('h1') || topLevelElement.is('h2') || topLevelElement.is('h3'))
			return topLevelElement;
		return null;
	}
}

export const ValidateHeaderTagNameCore = HeaderFunctions.ValidateHeaderTagNameCore;
export const GetRecognizedHeaderVariantAttributeValue = HeaderFunctions.GetRecognizedHeaderVariantAttributeValue;
export const GetRecognizedHeaderComboForElement = HeaderFunctions.GetRecognizedHeaderComboForElement;
export const GetRecognizedHeaderCombo = HeaderFunctions.GetRecognizedHeaderCombo;
export const GetRecognizedHeaderCombosForTag = HeaderFunctions.GetRecognizedHeaderCombosForTag;

export function CreateLectioHeaderStyle(definition: CKEDITOR.styleDefinition, variant: HeaderVariant | null,
	editor: CKEDITOR.editor, giveMeStyle: boolean): LectioStyle {

	function setHeaderVariantStuff(range: CKEDITOR.dom.range, styleElement: string, variant: HeaderVariant | null): void {
		const root = range.startPath().block;
		const ele = HeaderFunctions.ValidateHeaderTagNameCore(style.element);
		const recognizedCombo = ele ? HeaderFunctions.GetRecognizedHeaderCombo(ele, variant) : null;
		if (!recognizedCombo)
			throw new Error('Er det her ikke os selv der proever at lave en ugyldigt combo?');

		if (recognizedCombo && recognizedCombo.variant)
			root.setAttribute(headerVariantAttributeName, recognizedCombo.variant);
		else
			root.removeAttribute(headerVariantAttributeName);

		HeaderFunctions.UpdateHeaderInfoDisplayAttribute(root, recognizedCombo || (ele ? { tag: ele, variant: variant } : 'clear'));
	}

	const style = new CKEDITOR.style(definition);
	// style.getDefinition();
	// (style as any)._ = { enterMode: editor.config.enterMode };

	return {
		doit: () => {
			setHeaderVariantStuff(editor.getSelection()!.getRanges()[0], definition.element, variant);
			style.apply(editor);
			// Vi soerger selv for at der bliver sat de ids paa som der boer vaere. Hvis vi ikke goer det her, skal
			// der to undos (ctrl-z) til for at undoe overskriften.
			ensureLectioIds(editor);
		},
		element: definition.element,
		lectioVariant: variant,
		checkActive: (path, ed) => {
			const h = HeaderFunctions.GetHeaderElement(path);
			if (!h)
				return false;
			const elementMatch = style.checkActive(new CKEDITOR.dom.elementPath(h), ed);
			if (!elementMatch)
				return elementMatch;

			const variantRaw = h.getAttribute(headerVariantAttributeName);
			return (variantRaw || '') === (variant || '');
		},
		style: style,
	};
}

export type LectioStyle = {
	style: CKEDITOR.style;
	element: string;
	doit: () => void;
	lectioVariant: HeaderVariant | null;
	checkActive: (path: CKEDITOR.dom.elementPath, editor: CKEDITOR.editor) => boolean;
};

type LectioRichComboDefinition = CKEDITOR.ui.richComboDefinition & {
	lectioUpdateComboInBallonPanel: (this: CKEDITOR.ui.richCombo) => void;
};
type LectioRichCombo = CKEDITOR.ui.richCombo & {
	lectioUpdateComboInBallonPanel: LectioRichComboDefinition['lectioUpdateComboInBallonPanel'];
};

function CreateLectioFormatCombo(editor: CKEDITOR.editor, enableHeaderVariants: boolean): LectioRichComboDefinition {
	// 20180214: Flg. richcombo var en kopi af ckeditors eget "Format"-plugin/richcombo, som vi
	// har brugt indtil nu.
	if (editor.blockless)
		throw new Error('blockless');

	const config = editor.config,
		lang = editor.lang.format;

	// Gets the list of tags from the settings.
	const tags = config.format_tags!.split(';');

	// Create style objects for all defined styles.
	const styles: { [k: string]: LectioStyle } = {};
	const allowedContent: Array<LectioStyle> = [];
	for (const tag of tags) {
		const def: CKEDITOR.styleDefinition = (config as any)['format_' + tag];
		const combos = enableHeaderVariants ? HeaderFunctions.GetRecognizedHeaderCombosForTag(tag, false) : null;
		for (const r of combos || [{ nonHeader: tag }]) {
			const variant = 'nonHeader' in r ? null : r.variant;
			// const style = new CKEDITOR.style(def);
			const style = CreateLectioHeaderStyle(def, variant, editor, true);
			const key = tag + (variant !== null ? '_' + variant : '');
			if (key in styles)
				throw new Error('Findes allerede i styles?: ' + key);
			if (!editor.filter.customConfig || editor.filter.check(style)) {
				styles[key] = style;
				allowedContent.push(style);
			}
		}
	}

	function GetComboItemLabel(tag: string, variant: HeaderVariant | null): string {
		const header = HeaderFunctions.ValidateHeaderTagNameCore(tag);
		const label = header ? HeaderFunctions.GetHeaderTagAndVariantDisplay(header, variant, true) : lang['tag_' + tag];
		if (typeof label !== 'string')
			throw new Error('Fik ikke label. Tag: ' + tag + ', variant: ' + (variant || '(null)'));
		return label;
	}

	function update(combo: CKEDITOR.ui.richCombo, elementPath: CKEDITOR.dom.elementPath): void {
		const currentTag = combo.getValue();

		combo.refresh();

		for (const tag in styles) {
			const style = styles[tag];
			if (style.checkActive(elementPath, editor)) {
				const isVariantWithoutHeader = style.lectioVariant && !HeaderFunctions.GetHeaderElement(elementPath);
				if (isVariantWithoutHeader) {
					const label = GetComboItemLabel(style.element, null);
					combo.setValue(style.element, label);
				} else {
					const label = GetComboItemLabel(style.element, style.lectioVariant);
					combo.setValue(tag, label);
				}
				return;
			}
		}

		// If no styles match, just empty it.
		combo.setValue('');
	}

	return {
		label: lang.label,
		title: lang.panelTitle,
		toolbar: 'styles,20',
		// allowedContent: allowedContent,// udkommenteret fordi den ikke erklaeret i richComboDefinition.

		panel: {
			css: [CKEDITOR.skin.getPath('editor')].concat(config.contentsCss || []),
			multiSelect: false,
			attributes: { 'aria-label': lang.panelTitle }
		},

		init() {
			this.startGroup('Overskriftstype');

			for (const tag in styles) {
				const style = styles[tag];
				const label = GetComboItemLabel(style.element, style.lectioVariant);
				// Add the tag entry to the panel list.
				this.add(tag, '<span style="font-size: 85%;">' + label + '</span>', label);
			}
		},

		onClick: (value) => {
			editor.focus();
			editor.fire('saveSnapshot');

			const style = styles[value],
				elementPath = editor.elementPath();

			// Always apply style, do not allow to toggle it by clicking on corresponding list item (#584).
			if (!style.checkActive(elementPath, editor)) {
				style.doit();
				// editor.applyStyle(style);
			} else

				// Save the undo snapshot after all changes are affected. (https://dev.ckeditor.com/ticket/4899)
				setTimeout(() => {
					editor.fire('saveSnapshot');
				}, 0);
		},

		lectioUpdateComboInBallonPanel() {
			update(this, editor.getSelection()!.getRanges()[0].startPath());
		},
		onRender() {
			editor.on('selectionChange', function (ev) {
				const elementPath = ev.data.path;
				if (!(elementPath instanceof CKEDITOR.dom.elementPath))
					throw new Error('elementpath er ikke elementpath??');
				update(this, elementPath);
			}, this);
		},

		onOpen() {
			this.showAll();
			for (const name in styles) {
				const style = styles[name];

				// Check if that style is enabled in activeFilter.
				if (!editor.activeFilter.check(style.style))
					this.hideItem(name);
			}
		},

		refresh() {
			const elementPath = editor.elementPath();

			if (!elementPath)
				return;

			// Check if element path contains 'p' element.
			if (!elementPath.isContextFor('p')) {
				this.setState(CKEDITOR.TRISTATE_DISABLED);
				return;
			}

			// Check if there is any available style.
			for (const name in styles) {
				if (editor.activeFilter.check(styles[name].style))
					return;
			}
			this.setState(CKEDITOR.TRISTATE_DISABLED);
		}
	};
}

function OnNoteKey(evt: CKEDITOR.eventInfo & { data: { keyCode: number; }; }): void {
	// Lektienoter, redigering af: Ligger som almindelige blockquote-elementer, men vi vil gerne behandle dem lidt specielt:
	// De skal vaere flad tekst, og det skal vaere muligt at lave blanke linier (ligesom i et fler-linie-tekstfelt).
	// Imidlertid kan man ikke lave blanke linier (p-elementer uden reelt indhold) i editoren som standard:
	// Naar man trykker enter i en tom linie/tomt afsnit, bliver blockquoten enten hugget over eller curcoren hopper
	// ud af den.
	// Det laver vi om paa her, for vi vil istedet indsaette en ny, blank linie i form af et tomt afsnit.
	// Dog vil vi gerne holde det nemt at afslutte/hoppe ud af blockquoten og skrive videre, saa
	// vi lader ckeditor hoppe ud, hvis nuvaerende og foregaaende linie er tomme.

	if (evt.data.keyCode !== 13)
		return;
	const editor = evt.editor;
	const sel = editor.getSelection();
	if (!sel)
		return;
	const range = sel.getRanges()[0];
	if (!range.collapsed)
		return;
	// Vil genkende naar cursoren staar p-elementet i flg. struktur:
	// <hN>[lektieafsnitsoverskrift]</hN>
	// <blockquote data-lc-role="note">
	//   [noget]
	//   <p>&nbsp;</p>
	///  [noget]
	// </blockquote>
	const element = sel.getStartElement();
	const elementParent = element.getParent();
	if (!(element.getName() === 'p' && elementParent.getName() === 'blockquote' && elementParent.getAttribute('data-lc-role') === 'note'))
		return;
	function isEmptyLine(el: CKEDITOR.dom.element) {
		if (!(el.getChildCount() === 1))
			return false;
		const singleChild = el.getChild(0);
		// &nbpsp; i tomme p-elementer er i ckeditor-dom-en et br-element.
		if (singleChild instanceof CKEDITOR.dom.element && singleChild.getName() === 'br')
			return true;
		// Hvis afsnittet/linien bestaar af whitespace, er der en tekstnode.
		if (singleChild instanceof CKEDITOR.dom.text && singleChild.getText().trim() === '')
			return true;
		return false;
	}
	const prev = element.getPrevious(n => !(n instanceof CKEDITOR.dom.text && n.getText().trim() === ''));
	if (!(prev == null || prev instanceof CKEDITOR.dom.element))
		throw new Error('prev er ikke dom.element.');
	if (isEmptyLine(element) && (prev !== null && !isEmptyLine(prev))) {
		const newpara = new CKEDITOR.dom.element('p');
		newpara.setHtml('&nbsp');
		newpara.insertBefore(element);
		evt.cancel();
	}
}

function TryGetExternalIsPublicCheckBox(editor: CKEDITOR.editor): HTMLInputElement | null {
	const c = editor.container.$;
	const anc = $(c).parents('[data-role=homeworkitemdetails]')[0];
	const isHomeworkItemEditor = !!anc;
	if (!isHomeworkItemEditor)
		return null;

	const cb = anc.querySelector<HTMLInputElement>('[fezz=ispubliccontentcheckbox] input[type=checkbox]');
	return cb;
}

function CreateIsPublicCommand(): CKEDITOR.commandDefinition {
	return {
		exec(editor) {
			// Editorerne paa aktivitetsforsiden har deres egne flueben uden for editoren.
			const cb = TryGetExternalIsPublicCheckBox(editor);
			if (cb) {
				cb.checked = !cb.checked;
			} else {
				const element = HeaderFunctions.GetHeaderElement(editor.getSelection()!);
				if (!element)
					return false;

				const state = getIsPublicCommandTristate(element);
				if (state === CKEDITOR.TRISTATE_ON)
					element.removeAttribute(headerIsPublicAttributeName);
				else if (state === CKEDITOR.TRISTATE_OFF)
					element.setAttribute(headerIsPublicAttributeName, "");
				else
					throw new Error('huh?');

				HeaderFunctions.UpdateHeaderInfoDisplayAttribute(element, 'derive');
			}

			if (!this.refresh)
				throw new Error('hold saa op, typescript, this.refresh kan ikke vaere null.');

			this.refresh(editor, editor.elementPath());

			return true;
		},
		contextSensitive: true,
		refresh(editor, elementPath) {
			const cb = TryGetExternalIsPublicCheckBox(editor);
			let state: CKTristate;
			if (cb) {
				state = cb.checked ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF;
			} else {
				const element = HeaderFunctions.GetHeaderElement(elementPath);
				state = getIsPublicCommandTristate(element);
			}

			this.setState(state);
		}
	};

	function getIsPublicCommandTristate(element: CKEDITOR.dom.element | null): CKTristate {
		if (!element)
			return CKEDITOR.TRISTATE_DISABLED;

		const name = HeaderFunctions.ValidateHeaderTagName(element.getName());
		const variant = HeaderFunctions.ValidateHeaderTagVariantCore(element.getAttribute(headerVariantAttributeName) || '42');
		if (!name || !HeaderFunctions.SupportsIsPublic(name, variant))
			return CKEDITOR.TRISTATE_DISABLED;

		const p = element.getAttribute(headerIsPublicAttributeName);
		if (p === null)
			return CKEDITOR.TRISTATE_OFF;
		else
			return CKEDITOR.TRISTATE_ON;
	}
}

function CreateNoteCommand(lektieEditor: boolean): CKEDITOR.commandDefinition {
	return {
		exec: editor => {
			const header = HeaderFunctions.GetHeaderElement(editor.getSelection()!);
			if (!(header || lektieEditor))
				return false;

			let element: CKEDITOR.dom.element;
			if (header)
				element = header;
			else if (lektieEditor) {
				element = editor.elementPath().elements[0];
			}
			else
				throw new Error('ikke header eller lektieeditor.');

			const attribName = 'data-lc-role';
			const attribValue = 'note';

			const next = element.getNext((n: CKEDITOR.dom.node) => n instanceof CKEDITOR.dom.element) as CKEDITOR.dom.element;

			// Findes der allerede en kasse, som vi blot skal saette henlede brugerens opmaerksomhed paa?
			if (next && next.is('blockquote') && next.getAttribute(attribName) === attribValue) {
				const firstchild = next.getChildCount() >= 1 ? next.getChild(0) : null;
				if (!firstchild)
					throw new Error('blockquote uden elementer?');
				const r3 = editor.createRange();
				r3.moveToPosition(firstchild, CKEDITOR.POSITION_AFTER_START);
				const sel2 = editor.getSelection()!;
				sel2.selectRanges([r3]);
				return true;
			}

			editor.fire('saveSnapshot');
			editor.fire('lockSnapshot', { dontUpdate: true });

			// Lav p-element efter overskriften, ...
			const newPara = new CKEDITOR.dom.element('p');
			newPara.setHtml('&nbsp;');
			newPara.insertAfter(element);

			// ... som vi beder ckeditor om at lave om til blockqutoe ....
			const r = editor.createRange();
			r.selectNodeContents(newPara);
			const sel = editor.getSelection()!;
			sel.selectRanges([r]);
			editor.execCommand('blockquote');

			// ... og bagefter markerer med en attribut som vaerende en note.
			const r2 = sel.getRanges()[0];
			let cur = r.startContainer;
			let cnt = 0;
			while (!(cur instanceof CKEDITOR.dom.element && cur.getName() === 'blockquote')) {
				cnt++;
				if (cnt > 3)
					throw new Error('Fejl, har ikke fundet ancestor endnu.');
				cur = cur.getParent();
			}
			const blockquote = cur;
			blockquote.setAttribute(attribName, attribValue);

			// Aht. undo.
			editor.fire('unlockSnapshot');

			return true;
		},
		contextSensitive: true,
		refresh(editor, elementPath) {
			let state: CKTristate;
			if (lektieEditor)
				state = CKEDITOR.TRISTATE_OFF;
			else {
				const element = HeaderFunctions.GetHeaderElement(elementPath);
				state = getNoteCommandTristate(element);
			}

			this.setState(state);
		}
	};

	function supportsNote(tag: HeaderTag, variant: HeaderVariant | null): boolean {
		if (tag === 'h1' && variant === 'activity')
			return true;
		if (tag === 'h2' && (variant === 'homework' || variant === 'other'))
			return true;
		return false;
	}

	function getNoteCommandTristate(element: CKEDITOR.dom.element | null): CKTristate {
		if (!element)
			return CKEDITOR.TRISTATE_DISABLED;

		const name = HeaderFunctions.ValidateHeaderTagName(element.getName());
		const variant = HeaderFunctions.ValidateHeaderTagVariantCore(element.getAttribute(headerVariantAttributeName) || '42');
		if (!name || !supportsNote(name, variant))
			return CKEDITOR.TRISTATE_DISABLED;

		return CKEDITOR.TRISTATE_OFF;
	}
}
